/* CrispyCards Pokémon Karten – robustes Badge-Rendering, nur in eigener Section */
(function () {
  'use strict';
  if (window.__ccKartenBadgesV2) return;
  window.__ccKartenBadgesV2 = true;

  function makeBadge(text, kind) {
    var el = document.createElement('span');
    el.className = 'cc-karten-badge cc-karten-badge--' + kind;
    el.textContent = text;
    return el;
  }

  function refresh() {
    document.querySelectorAll('.cc-karten-collection').forEach(function (section) {
      var records = new Map();
      section.querySelectorAll('.cc-karten-data [data-cc-product-id]').forEach(function (node) {
        records.set(String(node.getAttribute('data-cc-product-id')), node.dataset);
      });

      section.querySelectorAll('.grid-product[data-product-id]').forEach(function (card) {
        var data = records.get(String(card.getAttribute('data-product-id')));
        if (!data) return;

        var image = card.querySelector('.grid__item-image-wrapper') || card.querySelector('.grid-product__image-mask');
        if (!image) return;
        var sold = data.ccAvailable === 'false';
        var grade = (data.ccGrader && data.ccGrade) ? [data.ccGrader, data.ccGrade].join(' ').trim() : '';
        var signature = [sold, data.ccNew, data.ccSale, grade].join('|');
        if (card.dataset.ccLabelsV2 === signature && image.querySelector('.cc-karten-badges')) return;
        card.dataset.ccLabelsV2 = signature;

        card.querySelectorAll('.cc-karten-badges').forEach(function (node) { node.remove(); });
        card.classList.toggle('cc-karten-sold', sold);
        image.style.position = 'relative';

        var left = document.createElement('div');
        left.className = 'cc-karten-badges cc-karten-badges--left';
        if (sold) {
          left.appendChild(makeBadge('SOLD', 'sold'));
        } else {
          if (data.ccNew === 'true') left.appendChild(makeBadge('NEW', 'new'));
          if (data.ccSale === 'true') left.appendChild(makeBadge('HOT!', 'hot'));
        }
        if (left.childElementCount) image.appendChild(left);

        if (!sold && grade) {
          var right = document.createElement('div');
          right.className = 'cc-karten-badges cc-karten-badges--right';
          right.appendChild(makeBadge(grade, 'grade'));
          image.appendChild(right);
        }
      });
    });
  }

  var queued = false;
  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  }
  function start() {
    queueRefresh();
    new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queueRefresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
